import React from "react";
import "./ProgressBar.scss";

const ProgressBar = ({ progress, color }) => (
  <div className="ProgressBar">
    <div className="track">
      <div
        className="bar"
        data-complete={progress === 100 ? true : false}
        style={{ backgroundColor: color, width: `${progress}%` }}
      />
    </div>
  </div>
);

export default ProgressBar;
